"use client";

import ScrollReveal from "./ScrollReveal";

const stats = [
  { value: "150+", label: "Happy Clients" },
  { value: "15", label: "Years of Excellence" },
];

export default function Stats() {
  return (
    <section className="py-20 md:py-28 bg-charcoal text-white relative overflow-hidden">
      {/* Background accent */}
      <div className="absolute inset-0 bg-gradient-to-br from-amber-900/20 via-transparent to-rose-900/20" />

      <div className="max-w-7xl mx-auto px-6 relative">
        <div className="flex flex-col sm:flex-row items-center justify-center gap-12 sm:gap-0 sm:divide-x sm:divide-amber-500/20">
          {stats.map((stat, index) => (
            <ScrollReveal key={index} direction="up" delay={index * 150}>
              <div className="text-center group sm:px-16">
                <span className="block font-display text-6xl md:text-7xl font-light text-amber-400 mb-3 group-hover:scale-105 transition-transform">
                  {stat.value}
                </span>
                <span className="text-sm uppercase tracking-[0.3em] text-white/70">
                  {stat.label}
                </span>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}
